import React from 'react';
import { cmsFieldErrorId } from './cmsFieldErrors';

interface CmsFieldErrorProps {
  /** The input the error is about; names the line for `aria-describedby`. */
  fieldId: string;
  message?: string;
}

/** What CMS (or SHP) would refuse in a field, in the form's error style. */
export const CmsFieldError: React.FC<CmsFieldErrorProps> = ({
  fieldId,
  message,
}) =>
  message ? (
    <p
      id={cmsFieldErrorId(fieldId)}
      className='mt-1 text-xs text-destructive'
      role='alert'
    >
      {message}
    </p>
  ) : null;
